<template>
    <div class="card">
        <div class="card-header text-6xl">
            TIỆC BÁO HỶ
        </div>
        <div class="invitation">
            <div class="invitation-image-section">
                <img :src="imageSrc" :alt="imageAlt" class="invitation-image" />
                <h2 class="couple-names mt-4">{{ coupleNames }}</h2>
                <div class="invitation-date">14.06.2025</div>
            </div>
            <div class="invitation-details-section mt-5">
                <!-- <div class="invitation-header">
                <p>CHÚNG MÌNH SẼ VỀ CHUNG MỘT NHÀ!</p>
            </div> -->
                <!-- <div class="invitation-body">
                    <p class="invitation-locations">
                        <a class="venue-info" :href="ceremonyAddress" target="_blank" rel="noopener">
                            <span class="start-time"> {{ ceremonyStartTime }}</span>
                            <span class="venue-name">{{ ceremonyName }}</span>
                            <span class="location-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none"
                                    viewBox="0 0 24 24">
                                    <path fill="#b23a48"
                                        d="M12 2C7.03 2 3 6.03 3 11c0 5.25 7.05 10.61 8.01 11.29a1 1 0 0 0 1.18 0C13.95 21.61 21 16.25 21 11c0-4.97-4.03-9-9-9zm0 18.88C9.14 18.07 5 14.47 5 11c0-3.87 3.13-7 7-7s7 3.13 7 7c0 3.47-4.14 7.07-7 9.88z" />
                                    <circle cx="12" cy="11" r="3" fill="#b23a48" />
                                </svg>
                            </span>
                        </a>
                        <a class="venue-info" :href="partyAddress" target="_blank" rel="noopener">
                            <span class="start-time"> {{ partyStartTime }}</span>
                            <span class="venue-name">{{ partyName }}</span>
                            <span class="location-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none"
                                    viewBox="0 0 24 24">
                                    <path fill="#b23a48"
                                        d="M12 2C7.03 2 3 6.03 3 11c0 5.25 7.05 10.61 8.01 11.29a1 1 0 0 0 1.18 0C13.95 21.61 21 16.25 21 11c0-4.97-4.03-9-9-9zm0 18.88C9.14 18.07 5 14.47 5 11c0-3.87 3.13-7 7-7s7 3.13 7 7c0 3.47-4.14 7.07-7 9.88z" />
                                    <circle cx="12" cy="11" r="3" fill="#b23a48" />
                                </svg>
                            </span>
                        </a>
                    </p>
                </div> -->
                <!-- <div class="divider"></div> -->
                <div class="invitation">Thân mời <span class="guest-name">{{ guestName }}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
import { guestNameService } from '@/services/guest-name.service';

export default {
    name: "InvitationCardComponent",
    props: {
        imageSrc: {
            type: String,
            default: require("@/assets/images/Thi&Tue_vintage.jpg"),
        },
        imageAlt: {
            type: String,
            default: "Wedding Couple",
        },
        coupleNames: {
            type: String,
            default: "Thi & Tuệ",
        },
    },
    data() {
        return {
            guestName: guestNameService.guestName || "Bạn",
        };
    },
    computed: {
        isAttending() {
            return this.toCeremony || this.toParty;
        },
    },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Playwrite+VN:wght@100..400&display=swap");

h2 {
    margin: 0;
}

.invitation-locations {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.invitation {
    font-family: "BeautiqueDisplay italic", cursive;
    font-size: 1.2rem;
    font-weight: 100;

    .guest-name {
        font-weight: 500;
        color: #b23a48;
        font-size: 1.5rem;
        padding: 0 10px;
        border-bottom: #b23a48 2px dotted;
    }
}

.start-time {
    font-weight: 700;
    text-decoration: none;
}

.invitation-card-container {
    display: flex;
    flex-direction: column;
    background: #fff;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    max-width: 1000px;
    margin: 40px auto;
    border-radius: 12px;
    overflow: hidden;
    padding-top: 20px;
}

.invitation-image-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.image-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.invitation-image {
    object-fit: contain;
    display: block;
    border-radius: 0;
    max-width: 65%;
}

.invitation-details-section {
    flex: 1;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    color: #333;
}

.couple-names {
    font-family: "Dancing Script", cursive;
    /* Example Google Font */
    font-size: 5.5rem;
    color: #b23a48;
    line-height: 1;
}

.invitation-date {
    font-family: "Stampa 2", cursive;
    font-size: 2rem;
    padding: 0 0 10px 0;
    width: 100%;

    p {
        margin: 0;
    }
}

.invitation-body p {
    font-size: 1.15rem;
    line-height: 3;
    margin: 0;
    color: #444;
}

.venue-info {
    white-space: nowrap;
    color: #b23a48;
    display: inline-flex;
    align-items: center;
    display: flex;
    justify-content: space-between;
    font-family: "Playwrite VN", sans-serif;
    gap: 4px;
}

.location-icon {
    display: inline-flex;
}

.divider {
    width: 108px;
    height: 2px;
    background-color: #b23a48;
    margin: 25px 0;
    align-self: center;
}



/* Media queries for responsiveness */
@media (max-width: 1024px) {

    .invitation {
        flex-direction: column;
    }

    .invitation-image-section {
    }

    .invitation-details-section {
        padding: 30px 0;
        align-items: center;
        /* Center text on mobile */
        text-align: center;
    }

    .couple-names {
        font-size: 5rem;
    }

    .invitation-body p,
    .invitation-footer p {
        font-size: 1.2rem;
    }

    .divider {
        align-self: center;
        /* Center divider on mobile */
    }

    .rsvp-form {
        align-items: center;
        /* Center form on mobile */
    }

    .form-group {
        align-items: center;
        /* Center form elements on mobile */
    }

    .form-group input,
    .form-group textarea,
    .form-group select {
        text-align: center;
        /* Center text inside input/select on mobile */
    }

    .submit-button {
        align-self: center;
        /* Center button on mobile */
    }

    .submit-message {
        text-align: center;
        /* Center message on mobile */
    }
    .invitation-image {
        max-width: 90%;
    }
}
</style>
